<div>
  <h2 class="pb-2 text-sm font-sans text-gray-900">{{ 'task_detail.name' | translate }}</h2>

 <input
   type="text"
   [readonly]="!!task.dates?.validationDate"
   class="form-input w-full block"
   [formControl]="control" />
</div>
